<template>
	<div class="language_sec">
		<div class="language-selector">
			<a
				class="nav-link dropdown-toggle active btn_head"
				href="#"
				id="languageDropdown"
				role="button"
				data-bs-toggle="dropdown"
				aria-expanded="false"
			>
				<img
					:src="getCurrentLanguage.icon"
					:alt="getCurrentLanguage.name"
					style="width: 14px; height: 14px"
				/>
				{{ getCurrentLanguage.name }}
			</a>
			<ul class="dropdown-menu" aria-labelledby="languageDropdown">
				<li
					v-for="item in locales"
					:key="item.code"
					@click="s_locale_code = item.code"
					:class="{ active: s_locale_code === item.code }"
				>
					<img
						:src="getLanguageIcon(item.code)"
						:alt="item.name"
						style="width: 16px; height: 16px"
					/>
					{{ item.name }}
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import iconEn from '@/assets/images/v2/icon/icon-en.svg';
import iconKo from '@/assets/images/v2/icon/icon-ko.svg';
import iconJa from '@/assets/images/v2/icon/icon-ja.svg';

export default {
	name: 'menuLang',
	data() {
		return {
			img: {
				iconEn: iconEn,
				iconKo: iconKo,
				iconJa: iconJa,
			},
		};
	},
	methods: {
		getLanguageIcon(code) {
			const { iconEn, iconKo, iconJa } = this.img;

			switch (code) {
				case 'ko-KR':
					return iconKo;
				case 'ja-JP':
					return iconJa;
				case 'en-US':
				default:
					return iconEn;
			}
		},
	},
	computed: {
		...mapState('common', ['locales']),
		s_locale_code: {
			get() {
				return this.$store.state.common.locale;
			},
			set(value) {
				this.$store.dispatch('common/setLocale', value);
			},
		},
		getCurrentLanguage() {
			const currentLocale = this.locales.find(
				locale => locale.code === this.s_locale_code,
			);
			const { iconEn, iconKo, iconJa } = this.img;

			if (!currentLocale) {
				return {
					name: 'English',
					icon: iconEn,
				};
			}

			let icon;
			switch (currentLocale.code) {
				case 'ko-KR':
					icon = iconKo;
					break;
				case 'ja-JP':
					icon = iconJa;
					break;
				case 'en-US':
				default:
					icon = iconEn;
					break;
			}

			return {
				name: currentLocale.name,
				icon: icon,
			};
		},
	},
};
</script>
